<ngx-loading-bar></ngx-loading-bar>
<app-header [isLoggedIn]="isLoggedIn"></app-header>      
<router-outlet></router-outlet>
<app-footer></app-footer>

